import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import { Typography } from '@fdha/web-ui-library';

import { getStyles } from './DeliveryEmptyState.styles';

interface DeliveryEmptyStateProps {
  isCanceled: boolean;
  isClosedDelivery?: boolean;
}

/**
 * Component to display when there are no meal selections in a delivery
 */
const DeliveryEmptyState: FC<DeliveryEmptyStateProps> = ({
  isCanceled,
  isClosedDelivery = false,
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  const getEmptyStateMessage = () => {
    return isCanceled
      ? 'No dishes selected for this delivery.'
      : "The patient will receive the default meals set by the Food Ops team. It's possible to set a custom menu by editing an open delivery.";
  };

  return (
    <Box sx={styles.emptyStateContainer}>
      <Typography variant="body1" style={styles.emptyStateText}>
        {getEmptyStateMessage()}
      </Typography>
    </Box>
  );
};

export default DeliveryEmptyState;
